import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import { LinkContainer } from 'react-router-bootstrap';
import {Container, Row, Col} from 'react-bootstrap'
import "./Start.css";

export default class Start extends Component {


chooseDifficulty = (diff) => {
    this.setState(this.difficulty = diff);
    console.log(this.difficulty)
}


    render() {
        return (
            <div className="Home">
                {/* <Jumbotron> */}
                    <h1>Where in Europe am I?</h1>
                    <span className="startIcon">? <i class="fas fa-map-marker-alt"></i> ¿</span>
                    <h3>Choose your level:</h3><br/>
                    <Container>
                    <Row>
                    <Col sm={2} md={3} lg={4}></Col>
                    <Col xs={12} sm={8} md={6} lg={4}> 
                        <LinkContainer to={{
                            pathname: "/main",
                            state: {diff: 2}
                            }} 
                            >
                            <Button variant="primary" block>
                                Easy
                            </Button>
                        </LinkContainer>
                        <LinkContainer to={{
                            pathname: "/main",
                            state: {diff: 4}
                            }} 
                            >
                            <Button variant="danger" block>
                                Hard
                            </Button>
                        </LinkContainer>
                        <LinkContainer to={{
                            pathname: "/main",
                            state: {diff: 19}
                            }} 
                            >
                            <Button variant="dark" block>
                                Impossible
                            </Button>
                        </LinkContainer>
                    </Col>
                    </Row>
                    </Container>
                {/* </Jumbotron> */}
            </div>
        );
    }


}